export default "__VITE_ASSET__ZqRtVwyc__"